/**
 * <s-wishlist-count> — Badge showing how many products are saved; hidden when empty.
 */
import { getItems, subscribe } from '@theme/wishlist-store';

class SWishlistCount extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    subscribe(() => this.#sync(), this.#ac.signal);
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    const count = getItems().length;
    this.textContent = count > 0 ? String(count) : '';
    this.hidden = count === 0;
  }
}

if (!customElements.get('s-wishlist-count')) {
  customElements.define('s-wishlist-count', SWishlistCount);
}
